import { CompanyValuesSection } from '@/components/about/CompanyValuesSection';
import { GallerySection } from '@/components/about/GallerySection';
import { MissionVisionSection } from '@/components/about/MissionVisionSection';
import { WhoWeAreSection } from '@/components/about/WhoWeAreSection';
import { PageHero } from '@/components/common/PageHero';
import { Seo } from '@/components/common/Seo';

export default function About() {
  return (
    <>
      <Seo
        title="O nama"
        description="Upoznajte Helmflex tim i način na koji planiramo, koordiniramo i pratimo poslovne projekte."
      />
      <PageHero
        eyebrow="Helmflex / O nama"
        title="O nama"
        description="Poslovni savetnici i projektni koordinatori koji pomažu timovima da definišu odgovornosti, prate rokove i završe dogovoreni posao."
      />
      <WhoWeAreSection />
      <MissionVisionSection />
      <CompanyValuesSection />
      <GallerySection />
    </>
  );
}
